module.exports = __webpack_public_path__ + "static/media/43.fd4ef254.jpg";